import React from 'react';
import { Layout, Flex, Button } from 'antd';
import { Link } from 'react-router-dom';
import { MenuFoldOutlined, MenuUnfoldOutlined } from '@ant-design/icons';

import MetaTags, { MetaTagsProps } from '../components/MetaTags';
import NavigationTopbar from './TopBar';
import Sidebar from './SideBar';
import PrerenderLogo from '~components/PrerenderLogo';
// import UsageLimitApproachAlert from '../features/usage-limit-approach-alert/UsageLimitApproachAlert';
import './AdminTemplate.css';
import { usePrerenderUserId } from '../hooks/usePrerenderUser';
import { AlertsContainer } from '~features/alerts';
import { FreeTrialModals } from '~features/FreeTrial';
import { WithSidePane } from './SidePane';

const LOCAL_STORAGE_KEY = 'sidebarCollapsed';

function loadCollapsedState(userId: number) {
  return localStorage.getItem(`${LOCAL_STORAGE_KEY}-${userId}`) === 'true' || false;
}

function saveCollapsedState(userId: number, value: boolean) {
  localStorage.setItem(`${LOCAL_STORAGE_KEY}-${userId}`, value.toString());
}

type AdminTemplateProps = {
  metaTags: MetaTagsProps['tags'];
  hasSidebar?: boolean;
  hasNavigation?: boolean;
};

function AdminTemplate({
  metaTags,
  hasSidebar = true,
  hasNavigation = true,
  children,
}: React.PropsWithChildren<AdminTemplateProps>) {
  const userId = usePrerenderUserId();
  const [collapsed, setCollapsed] = React.useState(() => loadCollapsedState(userId));

  const toggleCollapsed = () => {
    setCollapsed((prev) => {
      const newValue = !prev;
      saveCollapsedState(userId, newValue);
      return newValue;
    });
  };

  return (
    <>
      <MetaTags tags={metaTags} />
      <WithSidePane>
        <Layout>
          <Layout.Header
            style={{
              backgroundColor: 'white',
              borderBottom: '1px solid #f0f0f0',
              padding: '0 16px',
            }}
          >
            <Flex align="center" style={{ height: '100%' }}>
              <Flex align="center" gap="middle" flex={1}>
                {hasSidebar && (
                  <Button
                    icon={collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
                    onClick={toggleCollapsed}
                    style={{ width: 50 }}
                    aria-label="sidebar collapse"
                  />
                )}

                <Link to="/" style={{ display: 'flex' }}>
                  <PrerenderLogo />
                </Link>
                <NavigationTopbar navigationLocked={!hasNavigation} />
              </Flex>
            </Flex>
          </Layout.Header>

          <Layout hasSider={hasSidebar}>
            {hasSidebar && (
              <Layout.Sider
                trigger={null}
                width={280}
                collapsible
                collapsed={collapsed}
                theme="light"
                style={{
                  overflow: 'auto',
                  height: '100vh',
                  position: 'sticky',
                  top: 0,
                  left: 0,
                  bottom: 0,
                  paddingBottom: 60,
                  scrollbarWidth: 'thin',
                }}
              >
                <Sidebar isCollapsed={collapsed} />
              </Layout.Sider>
            )}
            <Layout.Content>
              <AlertsContainer />
              <FreeTrialModals />

              <div style={{ margin: '16px' }}>{children}</div>
            </Layout.Content>
          </Layout>
        </Layout>
      </WithSidePane>
    </>
  );
}

export default AdminTemplate;
